import { ChannelRoomStoreState } from "@obsbot/remo-stores";
import React, { ComponentType, memo } from "react";
import { useChannelroomStore } from "./use-channelroom-store";
import { RouteNameType } from "../route-config";
import { RouteParams } from "./routes";
import { useParams } from "react-router-dom";

export type WithChannelroomStoreProps<P = {}> = P & { channelroomStore?: ChannelRoomStoreState };

export const withChannelroomStore = <P extends {}>(
    Component: ComponentType<WithChannelroomStoreProps<P>>,
): React.FC<P> =>
    memo(function WithChannelroomStore(props) {
        const params =
            useParams<RouteParams<RouteNameType.ChannelRoomPage | RouteNameType.GameOverlayPage>>();
        // @ts-ignore
        const channelroomStore = useChannelroomStore({ ...params });
        return <Component channelroomStore={channelroomStore} {...props} />;
    });
